<template>
  <div class="features-manager">
    <table class="uk-table uk-table-small uk-table-justify">
      <draggable
        :options="{ handle: '.drag-handle'}"
        @end="onInput"
        element="tbody"
        v-model="features"
      >
        <tr class="features-manager__row" v-for="(feature, index) in features">
          <td class="uk-table-shrink">
            <drag-handle class="features-manager__drag-handle" />
          </td>
          <td class="uk-width-1-5">
            <text-input
              :disabled="disabled"
              :errors="internalErrors[index] && internalErrors[index].name"
              :label="false"
              :placeholder="$t('placeholders.name')"
              @blur="removeFeatureWhenEmpty(index)"
              @change="onInput()"
              ref="featureName"
              v-model="feature.name"
            />
          </td>
          <td>
            <textarea-input
              :collapse="true"
              :disabled="disabled"
              :errors="internalErrors[index] && internalErrors[index].value"
              :label="false"
              :placeholder="$t('placeholders.value')"
              @blur="removeFeatureWhenEmpty(index)"
              @change="onInput()"
              ref="featureValue"
              v-model="feature.value"
            />
          </td>
          <td class="uk-table-shrink">
            <ul
              class="uk-iconnav data-grid-actions uk-float-right features-manager__actions uk-preserve-width"
            >
              <li>
                <a
                  @click.prevent="maybeRemoveFeature(index)"
                  href="#"
                  tabindex="-1"
                >
                  <icon name="trash" />
                </a>
              </li>
            </ul>
          </td>
        </tr>
      </draggable>

      <tfoot class="features-manager__footer">
        <tr>
          <td class="uk-table-shrink" v-if="hasItems"></td>
          <td class="uk-width-1-5">
            <text-input
              :disabled="disabled"
              :label="false"
              :placeholder="$t('placeholders.name')"
              @input="addFeatureWithName"
              ref="newFeatureName"
              v-model="newFeature.name"
            />
          </td>
          <td>
            <textarea-input
              :disabled="disabled"
              :label="false"
              :placeholder="$t('placeholders.value')"
              @input="addFeatureWithValue"
              v-model="newFeature.value"
            />
          </td>
          <td class="uk-table-shrink" v-if="hasItems"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import pick from 'lodash/pick';
import UIkit from 'uikit';
import DataGridActions from '@/components/DataGridActions';
import DragHandle from '@/components/DragHandle';
import TextareaInput from '@/components/TextareaInput';
import TextInput from '@/components/TextInput';

function buildFeatures(features) {
  return (features || []).map(feature => pick(feature, ['name', 'value']));
}

export default {
  name: 'features-manager',
  components: {
    DataGridActions,
    Draggable,
    DragHandle,
    TextareaInput,
    TextInput,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  data() {
    return {
      features: buildFeatures(this.value),
      newFeature: { name: null, value: null },
      internalErrors: this.errors.map(error => error || {}),
    };
  },
  watch: {
    value(value) {
      this.features = buildFeatures(value);
    },
  },
  computed: {
    hasItems() {
      return this.features.length > 0;
    },
  },
  methods: {
    onInput() {
      this.$emit('input', this.features);
      this.$emit('change', this.features);
    },
    async maybeRemoveFeature(index) {
      try {
        const message = this.$t('confirmations.removeFeature');
        await UIkit.modal.confirm(message);
        this.removeFeature(index);
      } catch (_) {
        // Do nothing
      }
    },
    addFeatureWithName(name) {
      this.features.push({ name, value: null });
      this.focusLastFeature('featureName');
      this.onInput();
    },
    addFeatureWithValue(value) {
      this.features.push({ name: null, value });
      this.focusLastFeature('featureValue');
      this.onInput();
    },
    focusLastFeature(key) {
      this.$nextTick(() => {
        const lastIndex = this.features.length - 1;
        this.$refs[key][lastIndex].focus();
        this.newFeature.name = null;
        this.newFeature.value = null;
      });
    },
    removeFeature(index) {
      this.features.splice(index, 1);
      // TODO: Remove error for feature
    },
    removeFeatureWhenEmpty(index) {
      const entry = this.features[index];
      if (entry && !entry.name && !entry.value) {
        this.removeFeature(index);
        this.$nextTick(() => {
          this.$refs.newFeatureName.focus();
        });
      }
    },
  },
  i18n: {
    messages: {
      de: {
        confirmations: {
          removeFeature: 'Feature wirklich entfernen?',
        },
        placeholders: {
          name: 'Bezeichnung',
          value: 'Text',
        },
      },
    },
  },
};
</script>

<style scoped>
.features-manager__actions,
.features-manager__drag-handle {
  margin-top: 7px;
}

.features-manager__footer {
  font-size: inherit;
}
</style>



// WEBPACK FOOTER //
// FeaturesManager.vue?fe766ba0